export const TYPE_OPTS = ({ isActive, type, withChevron } = {}) => {
  const renderDefault = {
    true: {
      border: '',
      background: withChevron ? '' : 'bg-primary-50',
      text: 'text-primary-500',
      padding: 'px-ds-8',
    },
    false: {
      border: '',
      background: '',
      padding: 'px-ds-8',
      text: 'text-muted',
    },
  };

  const renderDisabled = {
    border: '!border-0',
    background: '!bg-primitive-white',
    text: '!text-disabled',
    padding: type === 'default' && 'px-ds-8',
  };

  return {
    default: renderDefault?.[isActive],
    disabled: renderDisabled,
  };
};
